import { Box, Button, Card, CardContent, CardMedia, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import { AnunciosData } from "../../types/Anuncio/AnuncioData"
import { useEffect, useState } from "react"
import { Area } from "../../types/Area/Area"
import { Audiencia } from "../../types/Audiencia/Audiencia"
import AreaService from "../../services/AreaService"
import AudienciaService from "../../services/AudienciaService"
import { Categoria } from "../../types/Categoria/Categoria"
import CategoriasService from "../../services/CategoriasService"
import { textDateFormat } from "../../utils/dateFormat"
import { FaMapMarkedAlt, FaLink } from "react-icons/fa";
import ImagePreviewer from "../../common/Behelit/ImagePreview"

interface Props {
    anuncio: AnunciosData
}

export const CardReview: React.FC<Props> = ({ anuncio }) => {
    const [areas, setAreas] = useState<Array<Area>>([]);
    const [audiencias, setAudiencias] = useState<Array<Audiencia>>([]);
    const [categorias, setCategorias] = useState<Array<Categoria>>([]);
    const [change, setChange] = useState(true);
    //Funciones
    const cambiarImagen = () => {
        setChange(!change);
    }
    const handleOpenLink = (link: string) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };
    const GetAreas = () => {
        try {
            AreaService.GetAreas()
                .then((resp) => {
                    if (resp) {
                        setAreas(resp);
                    }
                }).catch((error) => {
                    console.error(error)
                })
        } catch (error) {
            console.error(error)
        }
    }
    const GetCategorias = () => {
        try {
            CategoriasService.GetCategorias()
                .then((resp) => {
                    if (resp.status.isSuccessfully) {
                        setCategorias(resp.listData);
                    }
                }).catch((error) => {
                    console.error(error)
                })
        } catch (error) {
            console.error(error)
        }
    }
    const GetAudiencias = () => {
        try {
            AudienciaService.GetAudiencias()
                .then((resp) => {
                    if (resp) {
                        setAudiencias(resp);
                    }
                }).catch((error) => {
                    console.error(error)
                })
        } catch (error) {
            console.error(error)
        }
    }
    // Effects
    useEffect(() => {
        GetAreas();
        GetCategorias();
        GetAudiencias();
    }, []);
    return (
        <Grid container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item sm={12} md={6}>
                <Card sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Contenido orientado a la izquierda */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left', width: '100%' }}>
                        <CardContent sx={{ flex: '1 0 auto' }}>
                            <Typography component="div" variant="h5">
                                {anuncio.txTitulo}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                <strong>Tipo:</strong> {anuncio.bdTipo === 'A' ? 'Anuncio' : 'Evento'}
                            </Typography>
                            {anuncio.bdTipo === 'E' && (
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    {anuncio.nombreTipoEvento}
                                </Typography>
                            )}
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                <strong>Area:</strong> {areas.find((x) => x.idArea === anuncio.idArea)?.txNombreArea}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                <strong>Categoria:</strong>
                                <br />
                                {anuncio.categorias.map((cat, index) => (
                                    <Typography variant="body1" gutterBottom>
                                        {index + 1}. {cat.txNombreCategoria}
                                    </Typography>
                                ))}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                <strong>Audiencias Objetivo:</strong>
                            </Typography>
                            <ul>
                                {audiencias.map(aud => {
                                    return anuncio.audiencias.includes(aud.idAudiencia) ?
                                        <li key={aud.idAudiencia}>
                                            {aud.txNombre}
                                        </li>
                                        : <></>
                                })}
                            </ul>

                            {anuncio.txLugar !== null && anuncio.txLugar !== '' ?
                                <>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        <strong>Lugar:</strong> {anuncio.txLugar}
                                    </Typography>
                                </>
                                :
                                <></>
                            }
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                <strong>Ámbito:</strong> {anuncio.bdAmbito === 'A' ? 'Abierto' : 'Interno'}
                            </Typography>
                            {anuncio.dtPublicacion !== null ?
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    <strong>Fecha Publicación:</strong> {textDateFormat(anuncio.dtPublicacion)}
                                </Typography>
                                :
                                <></>
                            }
                            {anuncio.dtVigencia !== null ?
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    <strong>Fecha Vigencia:</strong> {textDateFormat(anuncio.dtVigencia)}
                                </Typography>
                                :
                                <></>
                            }
                            {anuncio.bdPublicarAutomatico !== null ?
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    <strong>Publicación Automática:</strong> {anuncio.bdPublicarAutomatico ? 'Sí' : 'No'}
                                </Typography>
                                :
                                <></>
                            }
                            {anuncio.txUrl && anuncio.txUrl !== '' ?
                                <Tooltip title={'enlace'} placement="top">
                                    <IconButton aria-label="delete" color="primary" onClick={() => handleOpenLink(anuncio.txUrl)}>
                                        <FaLink />
                                    </IconButton>
                                </Tooltip>
                                :
                                <></>
                            }
                            {anuncio.txtUrlMaps !== null && anuncio.txtUrlMaps !== '' ?
                                <Tooltip title={'Google Maps'} placement="top">
                                    <IconButton aria-label="delete" color="primary" onClick={() => handleOpenLink(anuncio.txtUrlMaps)}>
                                        <FaMapMarkedAlt />
                                    </IconButton>
                                </Tooltip>
                                : <></>
                            }
                        </CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                            <strong>Descripción:</strong>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                            {anuncio.txTexto}
                        </Box>
                    </Box>
                </Card>
            </Grid>
            <Grid item sm={12} md={6}>
                {change ?
                    <ImagePreviewer image={anuncio.txImagen} />
                    : <ImagePreviewer image={anuncio.txtImagenCaratula} />
                }
                <br />
                {anuncio.bdTipo === 'E' && (
                    <Button variant="contained" onClick={cambiarImagen}>
                        {change ? 'Carátula' : 'Imagen'}
                    </Button>)
                }
            </Grid>
        </Grid>
    )
}